import React, { useId } from 'react';
import { Form } from 'react-bootstrap';

/**
 * The phone counterpart of the sortable headers, for a table drawn as cards
 * whose headers are not shown.
 */
export default function SortBySelect({ controls, className = '' }) {
    const id = useId();
    const { key, direction } = controls.sort;
    const sortable = controls.columns.filter((c) => c.sortable !== false);
    const value = key ? `${key}:${direction}` : '';
    return (
        <Form.Group className={className}>
            <Form.Label htmlFor={id}>Sort by</Form.Label>
            <Form.Select
                id={id}
                value={value}
                onChange={(event) => {
                    const [nextKey, nextDirection] =
                        event.target.value.split(':');
                    controls.setSort(
                        nextKey
                            ? { key: nextKey, direction: nextDirection }
                            : { key: null, direction: 'asc' }
                    );
                }}
            >
                <option value="">Default order</option>
                {sortable.flatMap((column) => [
                    <option
                        key={`${column.key}:asc`}
                        value={`${column.key}:asc`}
                    >
                        {column.label}, ascending
                    </option>,
                    <option
                        key={`${column.key}:desc`}
                        value={`${column.key}:desc`}
                    >
                        {column.label}, descending
                    </option>,
                ])}
            </Form.Select>
        </Form.Group>
    );
}
